import Button from "../common/button";
import LinkButton from "../common/linkButton";


const UserPermissionsForm = (props) => {
  const {
    formTitle,
    hideTitle,
    submitLabel,
    submitAction,
    sendInviteField,
    children,
    disabled,
    hideAddRow,
    addAction,
    formSubmitPosition,
    cancelAction,
    addButtonLabel
  } = props;

  const formButtons = <div className='form-buttons'>
    {sendInviteField && sendInviteField}
    {cancelAction && <LinkButton label='Cancel' clickAction={cancelAction}/>}
    <Button label={submitLabel} action={submitAction} disabled={disabled}/>
  </div>


  return (
    <form className='user-permissions-form'>
      {formSubmitPosition === 'top' && formButtons}
      <div className='form-header'>
        <div className={hideTitle ? 'sr-hide' : 'form-title'}>{formTitle}</div>
      </div>
      <div className='form-body'>
        <div className='form-items'>
          {children}
          <div className={`form-add-row ${(hideAddRow === true) ? 'sr-hide' : ''}`}>
            <Button label={addButtonLabel ? addButtonLabel : 'Add'} action={() => addAction()}/>
          </div>
          {(!formSubmitPosition || formSubmitPosition === 'bottom') && formButtons}
        </div>
      </div>
    </form>
  );
};

export default UserPermissionsForm;